/**
 * @module Errors handle
 */
export default {
    namespaced: true,
    state: {

    },
    getters: {},
    mutations: {

    },
    actions: {

        handleErrors: function(state, data)
        {
            let dataErrors = '';

            if(data.error.response.data.errors === undefined)
            {
                dataErrors = 'La risorsa non è stata salvata';
            }
            else
            {
                dataErrors = data.error.response.data.errors;
            }

            state.commit(data.module, dataErrors, {root:true});
        }

    }
}